import { Box, BoxProps } from "@chakra-ui/react";

export function NonVisiableIcon({
  width = 16,
  height = 16,
  color = "#676879",
  ...props
}: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9531 9.20546C18.2065 9.56072 18.3332 9.73836 18.3332 10.0013C18.3332 10.2642 18.2065 10.4419 17.9531 10.7971C16.8148 12.3934 13.9075 15.8346 9.99984 15.8346C6.09215 15.8346 3.18492 12.3934 2.04654 10.7971C1.79318 10.4419 1.6665 10.2642 1.6665 10.0013C1.6665 9.73836 1.79318 9.56072 2.04654 9.20546C3.18492 7.60917 6.09215 4.16797 9.99984 4.16797C13.9075 4.16797 16.8148 7.60917 17.9531 9.20546Z"
          stroke="#5C6670"
          stroke-width="1.25"
        />
        <path
          d="M12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z"
          stroke="#5C6670"
          stroke-width="1.25"
        />
        <path
          d="M17.6138 2.17969L2.61377 17.1797"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
        />
      </svg>
    </Box>
  );
}
